import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import MailEdit from "../../components/MailEdit";

import Grid from "@mui/material/Grid";
import "./style.css";
import React, { useEffect, useState } from "react";
import axios from "axios";

import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { read } from "./api.js";
import { readEmpty } from "./apiEmpty.js";
import { useNavigate } from "react-router-dom";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";

import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";

import { Select, MenuItem } from "@mui/material";
import { purple } from "@mui/material/colors";
import { styled } from "@mui/material/styles";

const LIMIT = 6;

const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText(purple[500]),
  backgroundColor: purple[500],
  "&:hover": {
    backgroundColor: purple[700],
  },
}));

export default function CreatePost() {
  const navigate = useNavigate();

  const [skip, setSkip] = useState(0);
  const [posts, setPosts] = useState([]);
  const [query, setQuery] = useState("");
  const [searchThis, setSearchThis] = useState("Perusahaan");

  const [isEnd, setIsEnd] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const [previewVisibility, setPreviewVisibility] = useState(false);
  const [loadVisibility, setLoadVisibility] = useState(false);
  const [currPreview, setCurrPreview] = useState(null);
  const [fileURL, setFileURL] = useState("");

  const [editMailOpen, setEditMailOpen] = useState(false);
  const [useData, setUseData] = useState(null);

  useEffect(() => {
    let isCancelled = false;

    const fetchPosts = async () => {
      try {
        setIsLoading(true);
        setIsEnd("Loading...");

        let response;

        if (query.trim()) {
          response = await read(skip, query.trim(), searchThis);
        } else {
          response = await readEmpty(skip, "");
        }

        if (isCancelled) return;

        if (!response) {
          if (skip === 0) setPosts([]);
          setHasMore(false);
          setIsEnd("Error: backend tidak mengirim response.");
          return;
        }

        const { data, error } = response;

        if (error) {
          console.log(error);

          if (skip === 0) setPosts([]);

          setHasMore(false);
          setIsEnd(typeof error === "string" ? error : "Error loading data");
          return;
        }

        const list = Array.isArray(data) ? data : [];

        setPosts((prevPosts) => {
          if (skip === 0) {
            return list;
          }

          return [...prevPosts, ...list];
        });

        if (list.length === 0 && skip === 0) {
          setHasMore(false);
          setIsEnd("Data kosong");
        } else if (list.length < LIMIT) {
          setHasMore(false);
          setIsEnd("Selesai...");
        } else {
          setHasMore(true);
          setIsEnd("");
        }
      } catch (error) {
        console.log(error);

        if (!isCancelled) {
          if (skip === 0) setPosts([]);

          setHasMore(false);
          setIsEnd(error?.message || "Error loading data");
        }
      } finally {
        if (!isCancelled) {
          setIsLoading(false);
        }
      }
    };

    fetchPosts();

    return () => {
      isCancelled = true;
    };
  }, [skip, query, searchThis]);

  const newInquiry = () => {
    navigate("/new-inquiry", { state: { stuff: "new" } });
  };

  const editInquiry = (post) => {
    setUseData(post);
    setEditMailOpen(true);
  };

  const closeeditMailOpen = () => {
    setEditMailOpen(false);
    setUseData(null);
  };

  const previewPDF = async (post) => {
    try {
      setCurrPreview(post);
      setLoadVisibility(true);

      const id = post._id;

      const resp = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/renderKontrakVOfromDB`,
        { id },
        {
          responseType: "blob",
        }
      );

      const blob = new Blob([resp.data], { type: "application/pdf" });
      const fileURLNew = URL.createObjectURL(blob);

      setFileURL(fileURLNew);
      setPreviewVisibility(true);
    } catch (error) {
      console.log(error);
    } finally {
      setLoadVisibility(false);
    }
  };

  const handleScroll = (e) => {
    if (isLoading || !hasMore) return;

    const { offsetHeight, scrollTop, scrollHeight } = e.target;
    const isBottom = offsetHeight + scrollTop >= scrollHeight - 20;

    if (isBottom) {
      setSkip(posts.length);
    }
  };

  const handleSearch = (event) => {
    setPosts([]);
    setIsEnd("Loading...");
    setHasMore(true);
    setSkip(0);
    setQuery(event.target.value);
  };

  const handleSearchType = (event) => {
    setPosts([]);
    setIsEnd("Loading...");
    setHasMore(true);
    setSkip(0);
    setSearchThis(event.target.value);
  };

  const handleClosePreview = () => {
    setPreviewVisibility(false);
    setCurrPreview(null);
  };

  const editPI = (post) => {
    const targetPost = currPreview || post;

    if (!targetPost) return;

    navigate("/create-kontrak", {
      state: {
        data: targetPost,
        stuff: "edit",
      },
    });
  };

  const extend = (post) => {
    const targetPost = currPreview || post;

    if (!targetPost) return;

    navigate("/create-kontrak", {
      state: {
        data: targetPost,
        stuff: "extend",
      },
    });
  };

  const openSignatureNow = () => {
    console.log("Upload Tanda Tangan clicked");
  };

  return (
    <Grid container>
      <Dialog open={editMailOpen} onClose={closeeditMailOpen} maxWidth="xl" fullWidth>
        {useData && (
          <MailEdit useData={useData} closeeditMailOpen={closeeditMailOpen} />
        )}
      </Dialog>

      <Dialog
        open={loadVisibility}
        aria-labelledby="loading-dialog-title"
        aria-describedby="loading-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "100px",
            },
          },
        }}
      >
        <DialogContent>
          <Box sx={{ width: "100%" }}>
            <LinearProgress />
          </Box>
        </DialogContent>
      </Dialog>

      <Grid item xl={0.5} lg={0.7} md={0.9} sm={3.2} className="leftmenucolor">
        <LeftMenu />
      </Grid>

      <Grid item xl={10.8} lg={10.6} md={10.4} sm={8.8}>
        <Dialog
          open={previewVisibility}
          onClose={handleClosePreview}
          aria-labelledby="preview-dialog-title"
          aria-describedby="preview-dialog-description"
          sx={{
            "& .MuiDialog-container": {
              "& .MuiPaper-root": {
                width: "100%",
                maxWidth: "1250px",
              },
            },
          }}
        >
          <DialogTitle id="preview-dialog-title">
            <Button onClick={handleClosePreview} autoFocus>
              <CloseIcon />
            </Button>
          </DialogTitle>

          <DialogContent>
            <iframe
              title="PDF Preview"
              src={fileURL}
              width="100%"
              height="500"
              style={{ zoom: "150%" }}
            />

            <DialogContentText id="preview-dialog-description" />
          </DialogContent>

          <DialogActions>
            <Button variant="contained" color="error" style={{ marginRight: "auto" }}>
              Batal Kontrak
            </Button>

            <Button onClick={() => editPI()}>
              <EditIcon />
            </Button>

            <ColorButton variant="contained" onClick={openSignatureNow}>
              Upload Tanda Tangan
            </ColorButton>

            <Button onClick={() => extend()} variant="contained" color="success">
              Extend
            </Button>
          </DialogActions>
        </Dialog>

        <Grid
          className="boxshadowclass"
          position="fixed"
          width="98%"
          xs={12}
          zIndex="100"
          opacity="1"
        >
          <Header judul="Surat/Paket List" isi="Daftar semua Surat/Paket" />
        </Grid>

        <Grid sx={{ mt: 15 }} />

        <Grid sx={{ pl: 15 }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <Button onClick={newInquiry}>Create +</Button>
            </Grid>

            <Grid item xs={2}>
              <Select fullWidth value={searchThis} onChange={handleSearchType}>
                <MenuItem value="Perusahaan">Perusahaan</MenuItem>
                <MenuItem value="Klien">Klien</MenuItem>
                <MenuItem value="nomorTandaTerima">Tanda Terima</MenuItem>
              </Select>
            </Grid>

            <Grid item xs={4}>
              <TextField
                fullWidth
                value={query}
                onChange={handleSearch}
                placeholder="Cari surat..."
              />
            </Grid>
          </Grid>

          <Grid
            container
            justifyContent="center"
            alignItems="center"
            sx={{ mt: 2 }}
          >
            <Paper sx={{ width: "100%", overflow: "hidden" }}>
              <TableContainer
                sx={{ maxHeight: 500, minHeight: 440 }}
                className="min-h-screen h-screen overflow-scroll"
                onScroll={handleScroll}
              >
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell>No Dokumen</TableCell>
                      <TableCell>Perusahaan</TableCell>
                      <TableCell>Klien</TableCell>
                      <TableCell>Lokasi</TableCell>
                      <TableCell>Tipe Dokumen/Paket</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Tempat Penyimpanan</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {posts.map((post, index) => (
                      <TableRow
                        key={post?._id || index}
                        hover
                        onClick={() => editInquiry(post)}
                        style={{ cursor: "pointer" }}
                      >
                        <TableCell>
                          <p>{post?.dataSurat?.nomorTandaTerima ?? ""}</p>
                        </TableCell>

                        <TableCell>
                          <p>{post?.useData?.company?.namaPerusahaan ?? ""}</p>
                        </TableCell>

                        <TableCell>
                          <p>{post?.useData?.klien?.Nama ?? ""}</p>
                        </TableCell>

                        <TableCell>
                          <p>{post?.dataSurat?.lokasi ?? ""}</p>
                        </TableCell>

                        <TableCell>
                          <p>{post?.dataSurat?.TipeDok ?? ""}</p>
                        </TableCell>

                        <TableCell>
                          <p>{post?.statNotify ?? ""}</p>
                        </TableCell>

                        <TableCell>
                          <p>{post?.dataSurat?.storage ?? ""}</p>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <Box sx={{ p: 2 }}>
                {isLoading ? "Loading..." : isEnd}
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}